import * as React from "react";

import l10n from "diy/util/l10n";
import globalEvents = require("diy/util/globalEvents");

import Api from "../Api";

import {colors} from "material-ui/styles";
import Avatar from "material-ui/Avatar";
import mwsColors = require("diy/material-ui/colors");
import BellIcon from "material-ui/svg-icons/social/notifications";
import EmptyBellIcon from "material-ui/svg-icons/social/notifications-none";

export interface NotificationIconProps {

    /** Number of unread Notifications */
    counter: number;

    /** Has some Notifications in the Notification Center */
    hasNotifications: boolean;

    /** Icon is active yes/no */
    active?: boolean;
}

interface NotificationIconState {
    hover: boolean;
}

export default class NotificationIcon extends React.Component<NotificationIconProps, NotificationIconState> {

    constructor(props: NotificationIconProps) {
        super(props);

        this.state = {
            hover: false
        };
    }

    handleClick = () => {
        Api.schedule(() => {
            Api.toggleCenter();
        });

        /** Click Tracking */
        globalEvents.trigger("diy-editor-generic-sectionAccessed", {
            sectionCodeName: "notificationCenter"
        });
    };

    getStyles() {
        let styles: {
            root: React.CSSProperties;
            icon: React.CSSProperties;
            counter: React.CSSProperties;
        } = {
            root: {
                display: "block",
                marginTop: "-2px",
                marginRight: "10px",
                position: "relative"
            },
            icon: {
                color: mwsColors.mwsGrey500
            },
            counter: {
                height: "12px",
                width: "12px",
                color: colors.white,
                backgroundColor: "red",
                borderRadius: "6px",
                textAlign: "center",
                lineHeight: "12px",
                fontSize: "12px",
                position: "absolute",
                bottom: "5px",
                right: "3px"
            }
        };
        if (this.props.active || this.state.hover) {
            styles.icon.color = colors.blue500;
        }
        return styles;
    }

    render() {
        let styles = this.getStyles();

        let enableHover = () => {
            this.setState({
                hover: true
            });
        };

        let disableHover = () => {
            this.setState({
                hover: false
            });
        };

        let bellIcon = <BellIcon />;
        if (!this.props.hasNotifications) {
            bellIcon = <EmptyBellIcon />;
        }

        return (
            <a style={styles.root}
               title={l10n("notifications.iconText")}
               onClick={this.handleClick}
               onMouseEnter={enableHover}
               onMouseLeave={disableHover}
               data-test-id="notification-center-icon">

                <Avatar size={35}
                        icon={bellIcon}
                        style={styles.icon}
                        color={styles.icon.color}
                        backgroundColor="transparent">
                </Avatar>

                {(this.props.counter > 0)
                    ? <div style={styles.counter}>{this.props.counter}</div>
                    : ""}
            </a>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/components/NotificationIcon.tsx
 **/